module.exports = __webpack_public_path__ + "img/Weapon_04.68177e1a.png";